import { Checkbox, Col, Form, Input, Radio, Row, Select } from "antd";
import React, { useState } from "react";
import s from "./Register.module.scss";
import { Link, useNavigate } from "react-router-dom";
import {
  CheckCircleOutlined,
  EditOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { getEntityType } from "../../data";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../redux/AuthSlice";
import { IRegisterParams } from "../../types";
import { AppDispatch, RootState } from "../../redux/store";
import { notification } from "antd";
import { PhoneInput } from "react-international-phone";
// import "react-international-phone/style.css";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";
import LoginHeader from "../../components/Header/LoginHeader";
import MobileLoginHeader from "../../components/MobileHeader/MobileLoginHeader";

interface TCity {
  id: number;
  label: string;
  value: string;
}

const Register = () => {
  const [form] = useForm();

  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const [phone, setPhone] = useState("");
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const entity_type = getEntityType(t);
  const lang = useSelector((state: RootState) => state.application.lang);
  const managersList = useSelector(
    (state: RootState) => state.user.managersList,
  );

  const countries = useSelector((state: RootState) => state.auth.countries);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);

  const [userType, setUserType] = useState<string>("legal");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;

      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  const registerUser = async (values: IRegisterParams) => {
    try {
      const res = await dispatch(
        register({
          email: values.email,
          password: values.password,
          confirm_password: values.confirm_password,
          full_name: values.full_name,
          company_name: values.company_name,
          owner_name: values.owner_name,
          company_id: values.company_id,
          city: values.city,
          entity_type: values.entity_type,
          registered_country: values.registered_country,
          manager_id: values.manager_id,
          phone: values.phone,
        }),
      );

      if (res.type === "auth/register/fulfilled") {
        const message =
          res.payload && "message" in res.payload ? res.payload.message : "";

        openNotification(true, message, "success")();
        setTimeout(() => {
          navigate("/activateAccount");
        }, 3000);
      }
      if (res.type === "auth/register/rejected") {
        const errorMessage =
          res.payload && "error" in res.payload
            ? res.payload.error
            : "Произошла ошибка";

        openNotification(true, errorMessage, "error")();
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  const [isPasted, setIsPasted] = useState(false);

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    setIsPasted(true);

    form.setFields([
      {
        name: "confirm_password",
        errors: [t("Вставка пароля запрещена. Пожалуйста, введите вручную.")],
      },
    ]);
  };

  const handleChange = () => {
    if (isPasted) {
      setIsPasted(false);
      form.setFields([
        {
          name: "password",
          errors: [],
        },
      ]);
    }
  };

  return (
    <div>
      {width > 500 ? <LoginHeader /> : <MobileLoginHeader />}
      <div className={s.login}>
        {contextHolder}

        <h2 className={s.h2}>
          <EditOutlined className={s.icon} /> {t("Зарегистрироваться")}
        </h2>
        <Form
          className={s.form}
          layout="vertical"
          form={form}
          onFinish={registerUser}
        >
          <Row gutter={24}>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="full_name"
                label={t("ФИО представителя")}
                className={s.formItem}
                rules={[
                  {
                    required: true,
                    message: t("Укажите ФИО представителя"),
                  },
                  {
                    min: 2,
                    message: "Должно быть не менее 2х символов,",
                  },
                ]}
              >
                <input
                  placeholder={t("Укажите ФИО представителя")}
                  className={s.input}
                />
              </Form.Item>
            </Col>

            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="entity_type"
                label={t("Форма регистрации")}
                className={s.formItem}
                initialValue={"legal"}
              >
                <Radio.Group
                  block
                  options={entity_type}
                  onChange={(e) => setUserType(e.target.value)}
                  className={s.radio}
                />
              </Form.Item>
            </Col>
          </Row>
          {userType === "legal" ? (
            <Row gutter={24}>
              <Col span={width > 730 ? 12 : 24}>
                <Form.Item
                  name="company_name"
                  label={t("Наименование компании")}
                  className={s.formItem}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите наименование компании"),
                    },
                  ]}
                >
                  <input
                    placeholder={t("Укажите наименование компании")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>

              <Col span={width > 730 ? 12 : 24}>
                <Form.Item
                  name="company_id"
                  label={t("Идентификационный номер компании")}
                  className={s.formItem}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите Идентификационный номер компании"),
                    },
                  ]}
                >
                  <input
                    placeholder={t("Укажите Идентификационный номер компании")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
            </Row>
          ) : null}

          <Row gutter={24}>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="email"
                label={t("Email")}
                className={s.formItem}
                rules={[
                  {
                    required: true,
                    message: t("Укажите вашу электронную почту"),
                  },
                  { type: "email", message: t("Укажите корректный email") },
                ]}
              >
                <input
                  placeholder={t("Укажите вашу электронную почту")}
                  className={s.input}
                />
              </Form.Item>
            </Col>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="phone"
                label={t("Телефон")}
                className={s.formItem}
                rules={[
                  {
                    required: true,
                    message: t("Укажите контактный номер телефона"),
                  },
                ]}
              >
                <PhoneInput
                  defaultCountry="md"
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                  className={s.phone_input}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="registered_country"
                label={t("Страна регистрации компании")}
                className={s.formItem}
                rules={[
                  {
                    required: true,
                    message: t("Выберите страну регистрации компании"),
                  },
                ]}
              >
                <Select
                  className={s.select}
                  showSearch
                  placeholder={t("Выберите страну регистрации компании")}
                  options={countries?.map((it) => ({
                    value: it?.id,
                    label: it?.transit_country_name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item name="city" label={t("Город")} className={s.formItem}>
                <input
                  placeholder={t("Укажите город регистрации компании")}
                  className={s.input}
                  value={""}
                  defaultValue={""}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="password"
                label={t("Пароль")}
                className={s.formItem}
                rules={[
                  { required: true, message: t("Введите пароль") },
                  {
                    min: 8,
                    message: t("Пароль должен состоять минимум из 8 символов"),
                  },
                  {
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                    message: t(
                      "Пароль должен иметь минимум одну заглавную, одну прописную буквы и цифру",
                    ),
                  },
                ]}
              >
                <Input
                  className={s.password_input}
                  type={showPassword ? "text" : "password"}
                  suffix={
                    showPassword ? (
                      <EyeOutlined onClick={togglePasswordVisibility} />
                    ) : (
                      <EyeInvisibleOutlined
                        onClick={togglePasswordVisibility}
                      />
                    )
                  }
                  placeholder={t("Введите пароль")}
                />
              </Form.Item>
            </Col>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="confirm_password"
                label={<span>{t("Подтвердитe пароль")}</span>}
                dependencies={["password"]}
                className={s.formItem}
                rules={[
                  { required: true, message: t("Введите пароль еще раз") },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(t("Пароли не совпадают!")),
                      );
                    },
                  }),
                ]}
              >
                <Input
                  className={s.password_input}
                  type={showConfirmPassword ? "text" : "password"}
                  onPaste={handlePaste}
                  onChange={handleChange}
                  suffix={
                    showConfirmPassword ? (
                      <EyeOutlined
                        onClick={toggleConfirmPasswordVisibility}
                        className={s.password_icon}
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        onClick={toggleConfirmPasswordVisibility}
                      />
                    )
                  }
                  placeholder={t("Введите пароль еще раз")}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={width > 730 ? 12 : 24}>
              <Form.Item
                name="manager_id"
                label={t("Региональный представитель")}
                className={s.formItem}
              >
                <Select
                  className={s.select}
                  showSearch
                  placeholder={t("Выберите регионального представителя")}
                  options={managersList?.map((it) => ({
                    value: it?.id,
                    label: `${it?.registered_country} - ${it.email}`,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={width > 730 ? 12 : 24}>
            <Form.Item
              name=" "
              rules={[
                {
                  required: true,
                  message: t("Ознакомьтесь с условиями договора"),
                },
              ]}
              className={s.formItem}
            >
              <Col span={24}>
                <Checkbox className={s.checkbox}>
                  {t("Я ознакомлен и полностью согласен с условиями")}{" "}
                  <Link
                    to={"/files/Contract MCTAC-USER ENG.pdf"}
                    className={s.link}
                    target="_blank"
                  >
                    {t("Договора")}
                  </Link>
                </Checkbox>
              </Col>
            </Form.Item>
          </Row>

          <Row>
            <button className={s.enter_btn}>{t("Зарегистрироваться")}</button>
          </Row>
          <div className={s.no_account}>
            {t("Уже есть аккаунт?")} &nbsp;
            <Link to="/login" className={s.register_btn}>
              {t("Войти")}
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Register;
